import { render, staticRenderFns } from "./Splashes.vue?vue&type=template&id=6fe56c71"
import script from "./Splashes.vue?vue&type=script&lang=js"
export * from "./Splashes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports